import { gql } from "@apollo/client"

export const GET_TOURNAMENT_DETAIL = gql`
  query Tournament($id: Int!) {
    Tournament(id: $id) {
      TournamentPlayers(paginate: 9999) {
        id
        byes
        drop
        raceId
        TournamentRoundDrop {
          name
        }
        Person(orderBy: fullName_ASC) {
          id
          fullName
          code
          email
          avatar
          urlAvatar
        }
      }

      id
      description
      eventUrl
      gameId
      formatId
      statusId
      storeId
      typeId
      seasonId
      private
      image
      urlImage
      maxPlayers
      name
      rankingValid
      rounds
      startDate
      urlAddPlayers
      urlEdit
      urlRounds
      urlStandings
      urlView
      validDates
      isPresential
      Store {
        id
        name
        description
        phone
        email
        siteUrl
        active
        logo
        urlView
        Level {
          name
          description
        }
        Person {
          id
          avatar
          fullName
          urlAvatar
          code
        }
      }
      addressId
      Address {
        name
        address
        Country {
          name
          iso
        }
        Region {
          fullName
        }
        Location {
          name
        }
      }
      seasonId
      Season {
        name
        description
        startDate
        endDate
        rankingUrl
        Game {
          id
          name
        }
      }
      Game {
        id
        name
        urlImage
        RaceGames {
          raceId
          sortOrder
          Race {
            name
          }
        }
      }
      TournamentStatus {
        id
        name
        style
        description
        edit
      }
      TournamentType {
        name
        description
        winnerPoints
        minPlayers
        maxTopPlayers
        loserPoints
        drawPoints
        multiplier
        status
        urlImage
      }
      Format {
        id
        name
        description
        isFullRacial
      }
      TournamentRounds(orderBy: sortOrder_DESC, page: 1, paginate: 10) {
        id
        name
        statusId
      }
      TournamentRelateds {
        id
        quotas
        tournamentId
        relatedId
        Tournament {
          name
          startDate
          urlView
          urlImage
          isPresential
          TournamentType {
            name
            urlImage
          }
          Format {
            name
          }
          Season {
            name
            rankingUrl
            Game {
              name
            }
          }
          Address {
            Country {
              iso
            }
          }
          TournamentStatus {
            name
            style
          }
        }
      }
      TournamentClasifications {
        id
        quotas
        tournamentId
        relatedId
        TournamentRelated {
          name
          startDate
          urlView
          urlImage
          TournamentType {
            name
            urlImage
          }
          Format {
            name
          }
          Season {
            name
            rankingUrl
            Game {
              name
            }
          }
          Address {
            Country {
              iso
            }
          }
          TournamentStatus {
            name
          }
        }
      }
      TournamentOrganizers {
        id
        personId
        Person {
          id
          avatar
          fullName
          urlAvatar
          code
        }
      }
    }
  }
`

export const GET_TOURNAMENT_INFO = gql`
  query TournamentInfo($TournamentInfoInput: TournamentInfoInput!) {
    TournamentInfo(input: $TournamentInfoInput) {
      Related {
        id
        name
        statusId
        parentId
      }
      Tournament {
        id
        description
        eventUrl
        gameId
        formatId
        statusId
        storeId
        typeId
        seasonId
        image
        urlImage
        maxPlayers
        name
        rankingValid
        rounds
        startDate
        urlAddPlayers
        urlEdit
        urlRounds
        urlStandings
        urlView
        validDates
        isPresential
        isPrivate
        Store {
          id
          name
          description
          phone
          levelId
          active
          email
          siteUrl
          logo
          urlView
        }
        addressId
        Address {
          name
          address
          countryId
          regionId
          locationId
          Region
          Location
        }
        seasonId
        Season {
          name
          description
          isArchived
          isActive
          rankingUrl
          Game {
            id
            name
          }
        }
        Game {
          id
          name
          urlImage
          RaceGames {
            raceId
            sortOrder
            Race {
              name
            }
          }
        }
        TournamentStatus {
          id
          name
          style
          description
          edit
        }
        TournamentType {
          name
          description
          winnerPoints
          minPlayers
          maxTopPlayers
          loserPoints
          drawPoints
          multiplier
          status
          urlImage
          urlImage2
          urlImage3
          urlImage4
        }
        Format {
          id
          name
          description
          isFullRacial
        }
      }
      status {
        success
        name
        code
      }
    }
  }
`

export const GET_TOURNAMENT_PLAYERS = gql`
  query AllTournamentPlayers($TournamentPlayerFilterFilter: TournamentPlayerFilterFilter!) {
    allTournamentPlayers(filter: $TournamentPlayerFilterFilter, paginate: 900) {
      id
      personId
      Person {
        fullName
        urlAvatar
        avatar
        code
        email
        documentNumber
        documentNumberType
        Address {
          countryId
          regionId
        }
      }
      tournamentId
      classifiedId
      byes
      drop
      dropRoundId
      raceId
    }
  }
`

export const GET_TOURNAMENT_PLAYERS_SIMPLE = gql`
  query AllTournamentPlayers($TournamentPlayerFilterFilter: TournamentPlayerFilterFilter!) {
    allTournamentPlayers(filter: $TournamentPlayerFilterFilter, paginate: 900) {
      drop
      created
      Person {
        fullName
      }
    }
  }
`

export const GET_TOURNAMENT_ORGANIZERS = gql`
  query AllTournamentOrganizers(
    $TournamentOrganizerFilterFilter: TournamentOrganizerFilterFilter!
  ) {
    allTournamentOrganizers(filter: $TournamentOrganizerFilterFilter, paginate: 500) {
      id
      personId
      tournamentId
      Person {
        fullName
        urlAvatar
        avatar
        code
      }
    }
  }
`
